import { makeStyles, tokens } from '@fluentui/react-components';

const TEAMS_PURPLE = '#6264a7';

export const useNavigationMenuStyles = makeStyles({
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: tokens.colorNeutralBackground1,
    borderRight: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    transitionProperty: 'width',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
    overflow: 'hidden',
  },
  sidebarOpen: { width: '13.75rem' },
  sidebarCollapsed: { width: '3.25rem' },

  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    height: '4rem',
    flexShrink: '0',
    backgroundColor: TEAMS_PURPLE,
  },
  navToggle: {
    color: tokens.colorNeutralForegroundOnBrand,
    minWidth: '0',
  },
  brandText: {
    color: tokens.colorNeutralForegroundOnBrand,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  brandGroup: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXS,
    minWidth: 0,
  },

  nav: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0.125rem',
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    flex: '1',
    overflowY: 'auto',
  },
  navDivider: {
    height: tokens.strokeWidthThin,
    backgroundColor: tokens.colorNeutralStroke3,
    marginTop: tokens.spacingVerticalXS,
    marginBottom: tokens.spacingVerticalXS,
  },
});
